module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid4_400x300.ab402b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid4_400x300.jpg
// module id = 8R+G
// module chunks = 0